"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FeTextarea =
/*#__PURE__*/
function (_Component) {
  _inherits(FeTextarea, _Component);

  function FeTextarea(props) {
    var _this;

    _classCallCheck(this, FeTextarea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeTextarea).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var changeHandler = _this.props.changeHandler;
      var value = e.target.value;

      _this.setState({
        currentValue: value
      });

      if (changeHandler) changeHandler(e, value);
    });

    _this.state = {
      currentValue: props.initialValue,
      initialValue: props.initialValue
    };
    _this.id = (0, _lodash.default)('fabricTextarea-');
    return _this;
  }

  _createClass(FeTextarea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          label = _this$props.label,
          message = _this$props.message,
          messageType = _this$props.messageType,
          initialValue = _this$props.initialValue,
          textareaProps = _objectWithoutProperties(_this$props, ["disabled", "label", "message", "messageType", "initialValue"]);

      var currentValue = this.state.currentValue;
      var classes = (0, _classnames2.default)(_defineProperty({}, "fe-form__input-wrapper--has-".concat(messageType), message && messageType), 'fe-form__input-wrapper');
      return _react.default.createElement("div", {
        className: classes
      }, label && _react.default.createElement("label", {
        labelFor: this.id,
        className: "fe-input-label caption"
      }, label), _react.default.createElement("textarea", _extends({
        id: this.id,
        className: "fe-input",
        disabled: disabled,
        onChange: this.onChange
      }, textareaProps), currentValue), message && _react.default.createElement("span", {
        className: "fe-input-hint-text"
      }, message));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.initialValue !== state.initialValue) {
        return {
          currentValue: props.initialValue,
          initialValue: props.initialValue
        };
      }

      return null;
    }
  }]);

  return FeTextarea;
}(_react.Component);

FeTextarea.propTypes = {
  /** optional change handler, returns the event and the selected value (string | number) */
  changeHandler: _propTypes.default.func,

  /** Initial selected value */
  initialValue: _propTypes.default.string,

  /** Optional label above the select box */
  label: _propTypes.default.node,

  /** Optional message to be passed, a validation message for example */
  message: _propTypes.default.node,

  /** Optional message type */
  messageType: _propTypes.default.oneOf(['error', 'success', 'warning'])
};
var _default = FeTextarea;
exports.default = _default;